module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-how-we-teach-2ec82d5145274e8dbcedbc5ab0ba6731.webp";